import { DataGrid } from '@mui/x-data-grid'
import { Grid } from "@mui/material"

import styles from './campaignStyle'
import { withStyles } from '@material-ui/core/styles'
import { format } from 'date-fns'

const BullForce = ({ classes, visitorsInfo}) => {
    const rows = visitorsInfo.map((ele) => {
        return {
            "date": ele.date,
            "bullforce_co": ele.bullforce_co,
            "unique_bullforce_co": ele.unique_bullforce_co
        }
    })

    const columns = [
        {
            field: 'date',
            headerName: 'Date',
            width: 100,
            
        },
        {
            field: 'bullforce_co',
            headerName: 'Total Visits',
            width: 100,
            align: 'center'
        },
        {
            field: 'unique_bullforce_co',
            headerName: 'Unique Count',
            width: 100,
            align: 'center'
        }
    ]
 
    return (
        <Grid
        mt="6%"
        className={classes.horizantalTablayout}
        >
            <DataGrid
                className={classes.customDataGrid}

                rows={rows}
                columns={columns}
                getRowId={(row) => row.date}
                sx={{
                    '--DataGrid-containerBackground': '#131E2E',
                    '--DataGrid-rowBorderColor': '#000',
                    'border': 0,
                }}

                initialState={{
                    pagination: {
                        paginationModel: { page: 0, pageSize: 10 },
                    },
                }}

                pageSizeOptions={[10,  25, 50]} // Srini - 12/11/24
            />
        </Grid>
    )
}

export default withStyles(styles)(BullForce)